export default __webpack_public_path__ + "static/media/ntk.32b586ef.png";